// Treatments data for HomePage

export const featuredTreatments = [
  {
    title: "Five Nectar Herbal Steam",
    description:
      "Herbal steam therapy that detoxifies, restores energy, and rejuvenates body & mind.",
    icon: "fas fa-spa",
  },
  {
    title: "Ku Nye Massage",
    description:
      "Relax, rejuvenate, and strengthen body and mind with Ku-Nye therapy.",
    icon: "fas fa-hand-sparkles",
  },
  {
    title: "Salon",
    description: "Modern care to refresh your look and uplift your spirit.",
    icon: "fas fa-scissors",
  },
];
